import React, { createContext, FC, useContext } from 'react'
import { useFleetView } from '../hooks/useFleetView'

export interface IFleetViewContext extends ReturnType<typeof useFleetView> {}

export const FleetViewContext = createContext<IFleetViewContext>({} as IFleetViewContext)

export const FleetViewProvider: FC<IFleetViewContext> = ({ children, ...rest }) => {
  return <FleetViewContext.Provider value={rest}>{children}</FleetViewContext.Provider>
}

export const useFleetViewContext = () => useContext(FleetViewContext)
